const FormComponent = () => {
  const formBlock = document.querySelector('.form-component');
  if (!formBlock) return;

  // Dynamically load Dynamics FormLoader
  const script = document.createElement('script');
  script.src =
    'https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/che/FormLoader/FormLoader.bundle.js';
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    // Watch for the injected form (and its styles)
    const observer = new MutationObserver(() => {
      formBlock.querySelectorAll('style').forEach((style) => style.remove());
    });

    observer.observe(formBlock, {
      childList: true,
      subtree: true,
    });

    // Fail-safe: disconnect after 5s
    setTimeout(() => observer.disconnect(), 5000);
  };
};

export default FormComponent;
